export default "__VITE_ASSET__BxkxDceb__"